﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    brukerInfo?: Valg<BrukerInfo>;
    utdanning?: Valg<string>;
    land?: Valg<string>;
    periode?: Valg<Periode>;
    visUtbetaling: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';
export const TOGGLE_UTBETALING = 'TOGGLE_UTBETALING';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export interface ToogleUtbetalingAction {
    type: typeof TOGGLE_UTBETALING;
}

export interface BrukerInfo {
    fulltNavn: string,
    kjonn: string,
    fodt: string,
    mellom: string | null
}

export interface Periode {
    fraMaaned: string,
    fraAar: string,
    tilMaaned: string,
    tilAar: string
}


export type ValgStateActionTypes = UpdateValgAction | ToggleVilkarAction | ToogleUtbetalingAction;
